import { Box } from '@zoopla-eng/zds-components/box';
import { Link } from '@zoopla-eng/zds-components/link';
import { fontGroups } from '@zoopla-eng/zds-components/themes';
import { FC } from 'react';
import { containerStyle } from './DiscoverMore.styles.css';

type Props = {
    searchArea: string | null;
    housePricesUri: string | null;
    findAgentsUri: string | null;
};

export const DiscoverMore: FC<React.PropsWithChildren<Props>> = ({
    searchArea,
    housePricesUri,
    findAgentsUri
}) => {
    const sanitizeTrailingSlashes = (uri: string) => {
        const cleanedUri = uri.replace(/^\//, '').replace(/\/+$/, '');
        return `/${cleanedUri}/`;
    };

    return searchArea && housePricesUri && findAgentsUri ? (
        <div className={containerStyle}>
            <Box pt="M100" pb="S200">
                <h3 className={fontGroups.whisk}>
                    Discover more property information on Zoopla.
                </h3>
            </Box>
            <p>
                Explore{' '}
                <Link
                    key="prices"
                    href={sanitizeTrailingSlashes(housePricesUri)}
                    data-testid="house-prices-link"
                >
                    house prices in {searchArea}
                </Link>{' '}
                and{' '}
                <Link
                    key="agents"
                    href={sanitizeTrailingSlashes(findAgentsUri)}
                    data-testid="find-agents-link"
                >
                    find {searchArea} agents
                </Link>
            </p>
        </div>
    ) : null;
};
